<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text">
                        <p class="main">Fund Account</p>
                        <p class="sub">{{getCurrentAccountToFund[0]}}</p>
                    </div>
                </div>
            </div>
            <!--        Intro Text-->
            <div class="option-component">
                <div class="intro-text">
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="big">
                                Fund Account available in two options: From Other banks & cash deposit
                            </p>
                        </div>
                        <div class="col-sm-6">
                            <p class="small">
                                Fund your Rubies account by transfer from other banks to HIGSTREETS MFB,
                                Deposit cash to your Rubies account.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="options">
                    <div class="row">
                        <div class="col-sm-4">
                            <div @click="goToFundsFromOtherBanks()" class="opt">
                                <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <rect x="224" y="32" width="64" height="21.3"></rect>
                                        <rect x="149.3" y="384" width="21.3" height="21.3"></rect>
                                        <rect x="149.3" y="341.3" width="21.3" height="21.3"></rect>
                                        <rect x="192" y="384" width="21.3" height="21.3"></rect>
                                        <path d="M458.7 181.3c-14.7 0-37 5.1-53.3 20.4V32c0-17.7-14.3-32-32-32H138.7c-17.7 0-32 14.3-32 32v128h-32c-17.7 0-32 14.3-32 32v21.3c0 8.2 3.1 15.7 8.2 21.3 -5.1 5.7-8.2 13.1-8.2 21.3v21.3c0 8.2 3.1 15.7 8.2 21.3 -5.1 5.7-8.2 13.1-8.2 21.3v21.3c0 8.2 3.1 15.7 8.2 21.3 -5.1 5.7-8.2 13.1-8.2 21.3v21.3c0 17.7 14.3 32 32 32h32V480c0 17.7 14.3 32 32 32h234.7c17.7 0 32-14.3 32-32V248.6c1.7-22.8 19.3-41.9 42.7-44.8v297.5h21.3V192C469.3 186.1 464.6 181.3 458.7 181.3zM138.7 21.3h234.7C379.2 21.3 384 26.1 384 32v32H128V32C128 26.1 132.8 21.3 138.7 21.3zM64 341.3V320c0-5.9 4.8-10.7 10.7-10.7h32V352h-32C68.8 352 64 347.2 64 341.3zM64 277.3V256c0-5.9 4.8-10.7 10.7-10.7h32V288h-32C68.8 288 64 283.2 64 277.3zM64 192c0-5.9 4.8-10.7 10.7-10.7h32V224h-32C68.8 224 64 219.2 64 213.3V192zM74.7 416C68.8 416 64 411.2 64 405.3V384c0-5.9 4.8-10.7 10.7-10.7h32V416H74.7zM373.3 490.7H138.7c-5.9 0-10.7-4.8-10.7-10.7v-32h256v32C384 485.9 379.2 490.7 373.3 490.7zM384 426.7H128v-64 -64 -64 -64V85.3h256V426.7z"></path>
                                        <path d="M256 149.3c-58.9 0-106.7 47.8-106.7 106.7S197.1 362.7 256 362.7c58.9-0.1 106.6-47.8 106.7-106.7C362.7 197.1 314.9 149.3 256 149.3zM256 341.3c-47.1 0-85.3-38.2-85.3-85.3s38.2-85.3 85.3-85.3c47.1 0.1 85.3 38.2 85.3 85.3C341.3 303.1 303.1 341.3 256 341.3z"></path>
                                    </svg>
                                </span>
                                </div>
                                <p class="hed">Fund From Other Banks</p>
                                <p class="sub">You can from any of your bank accounts</p>
                            </div>
                        </div>

                        <!--<div class="col-sm-4">-->
                            <!--<div @click="goToFundsByCash()" class="opt">-->
                                <!--<div class="ico">-->
                                <!--<span>-->
                                    <!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.3 511.3">-->
                                        <!--<path d="M379.7 382.8H15V128.5h59.1c4.1 0 7.5-3.4 7.5-7.5 0-4.1-3.4-7.5-7.5-7.5H7.5c-4.1 0-7.5 3.4-7.5 7.5v269.3c0 4.1 3.4 7.5 7.5 7.5h65.2l27.9 60.3c1.7 3.7 6.2 5.4 10 3.6l27.4-12.7 82.9 59.2c3.3 2.4 8.1 1.6 10.5-1.7l77.5-108.6h70.8c4.1 0 7.5-3.4 7.5-7.5C387.2 386.1 383.8 382.8 379.7 382.8zM89.3 397.8H212.8l-101.6 47.1L89.3 397.8zM223.5 491.6l-69.9-49.9 94.8-44h42.1L223.5 491.6z"></path>-->
                                        <!--<path d="M503.8 113.5h-65.2l-27.9-60.3c-1.7-3.7-6.2-5.4-10-3.6l-27.4 12.7L290.3 3.1c-3.3-2.4-8.1-1.6-10.5 1.8l-77.5 108.6h-98.3c-4.1 0-7.5 3.4-7.5 7.5 0 4.1 3.4 7.5 7.5 7.5h102.2c0 0 0 0 0 0 0 0 0 0 0 0h227.5c0 0 0 0 0 0 0 0 0 0 0 0h62.5v254.3h-86.6c-4.1 0-7.5 3.4-7.5 7.5 0 4.1 3.4 7.5 7.5 7.5h94.1c4.1 0 7.5-3.4 7.5-7.5V121C511.3 116.8 507.9 113.5 503.8 113.5zM422 113.5H298.5L400.2 66.4 422 113.5zM287.7 19.7l69.9 49.9 -94.8 44h-42.1L287.7 19.7z"></path>-->
                                        <!--<path d="M255.6 327.3c39.5 0 71.6-32.1 71.6-71.6 0-39.5-32.1-71.6-71.6-71.6 -39.5 0-71.6 32.1-71.6 71.6C184.1 295.2 216.2 327.3 255.6 327.3zM255.6 199.2c31.2 0 56.6 25.4 56.6 56.6 0 31.2-25.4 56.6-56.6 56.6 -31.2 0-56.6-25.4-56.6-56.6C199.1 224.5 224.4 199.2 255.6 199.2z"></path>-->
                                        <!--<path d="M192.1 361h228.5c4.1 0 7.5-3.4 7.5-7.5 0-18.9 19-37.4 38.4-37.4 4.1 0 7.5-3.4 7.5-7.5V202.7c0-4.1-3.4-7.5-7.5-7.5 -19.4 0-38.4-18.5-38.4-37.4 0-4.1-3.4-7.5-7.5-7.5H86.6c-4.1 0-7.5 3.4-7.5 7.5 0 20-16.1 37.6-34.4 37.6 -4.1 0-7.5 3.4-7.5 7.5v105.6c0 4.1 3.4 7.5 7.5 7.5 18.3 0 34.4 17.6 34.4 37.6 0 4.1 3.4 7.5 7.5 7.5h75.6c4.1 0 7.5-3.4 7.5-7.5 0-4.1-3.4-7.5-7.5-7.5H93.5c-1.6-10.5-6.3-20.7-13.6-28.8 -7.7-8.5-17.3-13.9-27.7-15.7v-91.8c10.4-1.8 20-7.2 27.7-15.7 7.3-8.1 12.1-18.3 13.6-28.8h320.3c3.8 21.6 23.3 40.6 45.3 44.3v92.2c-22 3.6-41.5 22.7-45.3 44.3H192.1c-4.1 0-7.5 3.4-7.5 7.5C184.6 357.7 188 361 192.1 361z"></path>-->
                                    <!--</svg>-->
                                <!--</span>-->
                                <!--</div>-->
                                <!--<p class="hed">Cash Deposit</p>-->
                                <!--<p class="sub">Deposit cash at several branches</p>-->
                            <!--</div>-->
                        <!--</div>-->

                        <div class="col-sm-4">
                            <div @click="goToFundsByCard()" class="opt">
                                <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 937.5 937.5">
                                        <path class="a" d="M453.1 843.8L484.4 843.8 484.4 875 453.1 875ZM453.1 843.8"></path>
                                        <path class="a" d="M750 384.6L750 78.1C749.9 35 715 0.1 671.9 0L265.6 0C222.5 0.1 187.6 35 187.5 78.1L187.5 156.3 218.8 156.3 218.8 125 718.8 125 718.8 556 690.7 528C681.3 518.6 669.3 512 656.3 509.1L656.3 265.6C656.2 222.5 621.3 187.6 578.1 187.5L78.1 187.5C35 187.6 0.1 222.5 0 265.6L0 546.9C0.1 590 35 624.9 78.1 625L578.1 625C581.1 624.9 584.2 624.6 587.1 624.1 588.3 625.5 589.2 627 590.5 628.2L715.4 753.1 711.2 761.5C707.9 767.9 705.1 774.5 702.6 781.3L218.8 781.3 218.8 656.3 187.5 656.3 187.5 859.4C187.6 902.5 222.5 937.4 265.6 937.5L671.9 937.5C682.6 937.4 693.3 935.1 703.1 930.7L703.1 937.5 734.4 937.5 734.4 921.9C734.4 919.9 734 917.9 733.3 916.1 715 870.5 717.2 819.3 739.1 775.4L748.4 757C751.4 750.9 750.2 743.7 745.4 738.9L612.6 606.1C597.5 590.6 597.8 565.8 613 550.5 628.4 535.2 653.1 535 668.6 550.1L832.7 714.1 854.8 692 750 587.3 750 431 871.5 564.4C893.9 590 906.2 622.9 906.3 657L906.3 937.5 937.5 937.5 937.5 657C937.5 615.2 922.3 574.9 894.8 543.5ZM265.6 906.3C239.7 906.3 218.8 885.3 218.8 859.4L218.8 812.5 693.9 812.5C688.1 841.4 688.7 871.1 695.5 899.8 688.3 904 680.2 906.2 671.9 906.3ZM592.3 526.6C593.3 523 593.7 519.3 593.8 515.6 593.8 497.1 582.9 480.3 566 472.8 549.1 465.2 529.3 468.5 515.6 480.9 496.9 463.9 468 464.8 450.4 483 432.8 501.2 432.8 530.1 450.4 548.2 468 566.4 496.9 567.3 515.6 550.3 531.9 565.3 556.6 566.6 574.4 553.4 569.6 566.3 568.7 580.3 571.7 593.8L78.1 593.8C52.2 593.8 31.3 572.8 31.3 546.9L31.3 265.6C31.3 239.7 52.2 218.8 78.1 218.8L578.1 218.8C604 218.8 625 239.7 625 265.6L625 509.1C612.8 511.9 601.5 517.9 592.3 526.6ZM562.5 515.6C562.5 524.3 555.5 531.3 546.9 531.3 538.2 531.3 531.3 524.3 531.3 515.6 531.3 507 538.2 500 546.9 500 555.5 500 562.5 507 562.5 515.6ZM500 515.6C500 524.3 493 531.3 484.4 531.3 475.7 531.3 468.8 524.3 468.8 515.6 468.8 507 475.7 500 484.4 500 493 500 500 507 500 515.6ZM218.8 93.8L218.8 78.1C218.8 52.2 239.7 31.3 265.6 31.3L671.9 31.3C697.8 31.3 718.8 52.2 718.8 78.1L718.8 93.8ZM218.8 93.8"></path>
                                        <path class="a" d="M171.9 375C180.5 375 187.5 368 187.5 359.4L187.5 265.6C187.5 257 180.5 250 171.9 250L78.1 250C69.5 250 62.5 257 62.5 265.6L62.5 359.4C62.5 368 69.5 375 78.1 375ZM93.8 281.3L156.3 281.3 156.3 343.8 93.8 343.8ZM93.8 281.3"></path>
                                        <path class="a" d="M78.1 406.3L140.6 406.3 140.6 437.5 78.1 437.5ZM78.1 406.3"></path>
                                        <path class="a" d="M78.1 484.4L140.6 484.4 140.6 515.6 78.1 515.6ZM78.1 484.4"></path>
                                        <path class="a" d="M343.8 484.4L406.3 484.4 406.3 515.6 343.8 515.6ZM343.8 484.4"></path>
                                        <path class="a" d="M171.9 406.3L234.4 406.3 234.4 437.5 171.9 437.5ZM171.9 406.3"></path>
                                        <path class="a" d="M265.6 406.3L328.1 406.3 328.1 437.5 265.6 437.5ZM265.6 406.3"></path>
                                        <path class="a" d="M359.4 406.3L421.9 406.3 421.9 437.5 359.4 437.5ZM359.4 406.3"></path>
                                        <path class="a" d="M453.1 406.3L515.6 406.3 515.6 437.5 453.1 437.5ZM453.1 406.3"></path>
                                        <path class="a" d="M546.9 265.6L578.1 265.6 578.1 296.9 546.9 296.9ZM546.9 265.6"></path>
                                        <path class="a" d="M484.4 265.6L515.6 265.6 515.6 296.9 484.4 296.9ZM484.4 265.6"></path>
                                        <path class="a" d="M421.9 265.6L453.1 265.6 453.1 296.9 421.9 296.9ZM421.9 265.6"></path>
                                        <path class="a" d="M359.4 265.6L390.6 265.6 390.6 296.9 359.4 296.9ZM359.4 265.6"></path>
                                    </svg>
                                </span>
                                </div>
                                <p class="hed">Fund From Card</p>
                                <p class="sub">You can fund from any debit card</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <footer-mobile></footer-mobile>
        </div>

        <!--MODALS-->
        <!--Fund Account Modal-->
        <ui-modal
                ref="fundAccountModal" transition="scale-up"
                :removeHeader= "true" size="small" @hide="fundAccountModalHide"
                align-top :align-top-margin="150"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body history">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="quickTransfer">
                                    <div class="account-info">
                                        <p class="alias ">Account To Fund</p>
                                        <p class="name rubies-red">{{getCurrentAccountToFund[0]}}</p>
                                        <!--<p class="account">

                                        </p>-->
                                    </div>

                                    <div class="quickTransferForm">
                                        <div class="alert-box">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                        {{alert.message}}
                                                    </ui-alert>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 form-group mb-2">
                                                <label for="amount" class="form-label">Amount*</label>
                                                <div class="amount-input">
                                                    <div class="currency">
                                                        <span>&#8358;</span>
                                                    </div>

                                                    <input
                                                            type="text" id="amount" class="input"
                                                            value="" data-type="currency" placeholder="Amount" data-vv-name="Amount"
                                                            v-model="amount" name="amount" v-on:keypress="isNumber($event)" required
                                                            @change="amountOnChange(amount)"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="confirmCardFund()" class="btn btn-primary btn-xnax-login ">Next</button>
                    </div>
                </div>
            </div>
        </ui-modal>

        <!--UI Modal For Displaying Transfer Success Message-->
        <ui-modal
                ref="transferSuccessModal" transition="scale-up"
                :removeHeader= "true" size="small"
                align-top :align-top-margin="200"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-2">
                                <div class="left">
                                    <div class="status-icon">
                                        <svg class="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496.2 496.2">
                                            <path d="M496.2 248.1c0-137-111.1-248.1-248.1-248.1C111.1 0 0 111.1 0 248.1c0 137 111.1 248.1 248.1 248.1C385.1 496.2 496.2 385.1 496.2 248.1z"></path>
                                            <path d="M384.7 165c-5.8-15.1-17.7-12.7-30.6-10.1 -7.7 1.6-42 11.6-96.1 68.8 -22.5 23.7-37.3 42.6-47.1 57 -6-7.3-12.8-15.2-20-22.3 -22.1-22.1-46.7-37.2-47.7-37.9 -10.3-6.3-23.8-3.1-30.2 7.3 -6.3 10.3-3.1 23.8 7.2 30.2 0.2 0.1 21.4 13.2 39.6 31.5 18.6 18.6 35.5 43.8 35.7 44.1 4.1 6.2 11 9.8 18.3 9.8 1.2 0 2.5-0.1 3.8-0.3 8.6-1.5 15.4-7.9 17.5-16.3 0.1-0.2 8.8-24.3 54.7-72.7 37-39.1 61.7-51.5 70.3-54.9 0.1 0 0.1 0 0.3 0 0 0 0.3-0.1 0.8-0.4 1.5-0.6 2.3-0.8 2.3-0.8 -0.4 0.1-0.6 0.1-0.6 0.1l0-0.1c4-1.7 11.4-4.9 11.5-5C385.4 188.2 389 176.2 384.7 165z" fill="#FFF"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div class="col-10 pl-2">
                                <div class="right">
                                    <p>
                                        Congratulations!! <br>
                                        {{successMessage}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="closeModal('transferSuccessModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                    </div>
                </div>
            </div>
        </ui-modal>

        <!--UI Modal For Displaying Transfer Failed Message-->
        <ui-modal
                ref="transferFailModal" transition="scale-up"
                :removeHeader= "true" size="small"
                align-top :align-top-margin="200"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-2">
                                <div class="left">
                                    <div class="status-icon">
                                        <svg class="error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455.1 455.1">
                                            <circle cx="227.6" cy="227.6" r="227.6" fill="#E24C4B"></circle>
                                            <path d="M455.1 227.6c0 125.2-102.4 227.6-227.6 227.6 -72.5 0-136.5-32.7-177.8-85.3 38.4 31.3 88.2 49.8 142.2 49.8 125.2 0 227.6-102.4 227.6-227.6 0-54-18.5-103.8-49.8-142.2C422.4 91 455.1 155 455.1 227.6z" fill="#D1403F"></path>
                                            <path d="M331.4 331.4c-8.5 8.5-22.8 8.5-31.3 0l-72.5-72.5 -72.5 72.5c-8.5 8.5-22.8 8.5-31.3 0 -8.5-8.5-8.5-22.8 0-31.3l72.5-72.5 -72.5-72.5c-8.5-8.5-8.5-22.8 0-31.3 8.5-8.5 22.8-8.5 31.3 0l72.5 72.5 72.5-72.5c8.5-8.5 22.8-8.5 31.3 0 8.5 8.5 8.5 22.8 0 31.3l-72.5 72.5 72.5 72.5C339.9 308.6 339.9 322.8 331.4 331.4z" fill="#FFF"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div class="col-10 pl-2">
                                <div class="right">
                                    <p>
                                        Failed!! <br>
                                        {{errorMessage}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="closeModal('transferFailModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                    </div>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MobileLeftBar from "../sidebar/MobileLeftBar";
    import FooterMobile from "../utility/FooterMobile";

    export default {
        name: "FundMethod",
        components: {FooterMobile, MobileLeftBar },
        props: { },
        data () {
            return {
                currentFundCard: '',

                amount: '',

                dat: [],

                PayStackBody: {
                    // paystackkey: "pk_test_f04e457a192a4e2de2637a83bda9df477d94f809", //paystack public key
                    paystackkey: "pk_live_df63ea9216f0bc14ee85bec2e22eaba1ead1436b", //paystack public key
                    // email: this.getDataOnLogin.email, // Customer email
                    email: '', // Customer email
                    amount: 0 // in kobo
                },
                paymentComplete: false,

                successMessage: '',
                errorMessage: '',

                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
                'getUsername',
                'getCurrentAccountToFund',
            ]),

            scriptLoaded: function() {
                /**
                 * TODO:
                 * Find a fix to move promise away from computed
                 **/
                /* eslint-disable vue/no-async-in-computed-properties */
                return new Promise((resolve) => {
                    this.loadScript(() => {
                        resolve()
                    })
                })
            },
            reference(){
                let text = "";
                let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

                for( let i=0; i < 10; i++ )
                    text += possible.charAt(Math.floor(Math.random() * possible.length));
                return text;
            },
        },
        created () {},
        methods: {
            ...mapActions([
                'updateNetworkErrorState',
                'updateAppLoading',
                'updateSideBarPage',
                'updateInsideCurrentPage',
                'updateFullBankList',
                'updateCurrentTransferPhoneNo',
            ]),

            loadScript(callback) {
                const script = document.createElement('script')
                script.src = 'https://js.paystack.co/v1/inline.js'
                document.getElementsByTagName('head')[0].appendChild(script)
                if (script.readyState) {  // IE
                    script.onreadystatechange = () => {
                        if (script.readyState === 'loaded' || script.readyState === 'complete') {
                            script.onreadystatechange = null
                            callback()
                        }
                    }
                } else {  // Others
                    script.onload = () => {
                        callback()
                    }
                }
            },
            generateUUID () {
                let d = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
                });
                localStorage.test = uuid;
                return uuid
            },
            makeId() {
                let text = "";
                let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

                for (let i = 0; i < 4; i++)
                    text += possible.charAt(Math.floor(Math.random() * possible.length));

                return text;
            },
            backButton(){
                this.updateInsideCurrentPage('dashboard');
                this.updateSideBarPage('dashboard');
            },
            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            amountOnChange(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }
                // _incomingAmount = _incomingAmount.replace(/,/g, '');

                let outgoingAmount = this.cleanAmount(_incomingAmount);
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }

                this.amount = answer;
            },
            cleanAmount(_amount){
                _amount = _amount.replace(/,/g, '');
                _amount = (parseFloat(_amount).toFixed(2)).toString();

                return _amount
            },

            goToFundsFromOtherBanks(){
                //Open Modal FundsFromOtherBanks Modal

            },
            goToFundsByCash(){
                //Update the current sub component in the store
                this.updateInsideCurrentPage('cashFund')
            },
            goToFundsByCard(){
                //Update the current sub component in the store
                // this.updateInsideCurrentPage('cardFund')

                //display the fund account by card modal to collect amount
                this.openModal('fundAccountModal');
            },
            confirmCardFund(){
                if(this.amount === undefined || this.amount === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Enter Amount*')
                }
                else {
                    this.PayStackBody.amount = parseInt(this.cleanAmount(this.amount)) * 100;

                    this.PayStackBody.email =  this.getDataOnLogin.email;

                    console.log('PayStackBody ===>>', this.PayStackBody)

                    // this.startButtonLoader();
                    this.payWithPaystack();
                }
            },
            payWithPaystack(){
                let ref =  this.getCurrentAccountToFund[0] + this.reference + this.makeId();

                console.log('Ref',ref);

                this.scriptLoaded.then(() => {
                    const paystackOptions = {
                        key: this.PayStackBody.paystackkey,
                        email: this.getDataOnLogin.email,
                        amount: this.PayStackBody.amount,
                        ref: ref,
                        metadata: {
                            "reference": ref,
                            "Credit Account Name": this.getCurrentAccountToFund[0],
                            "Credit Account Number": this.getCurrentAccountToFund[1],
                        },
                        callback: (response) => {
                            this.callback(response)
                        },
                        onClose: () => {
                            this.PayStackModalClose()
                        },
                        currency: 'NGN',
                    };

                    if (this.embed) {
                        paystackOptions.container = 'paystackEmbedContainer'
                    }

                    const handler = window.PaystackPop.setup(paystackOptions);
                    if (!this.embed) {
                        handler.openIframe()
                    }
                })
            },
            PayStackModalClose(){
                console.log('Payment modal closed!')

                // stop App loading
                this.updateAppLoading(false)
            },
            callback(resp){
                console.log('PayStack Response  ===>>>', resp);
                console.log('Amount  ===>>>', this.amount);

                //start appLoading
                this.updateAppLoading(true)


                //    Display the success message in a modal and on close of that modal return to the dashboard (response.reference)
                axios
                    .post('/cardfunding', {
                        amount: this.amount,
                        accountnumber: this.getCurrentAccountToFund[0],
                        accountname: this.getCurrentAccountToFund[1],
                        customerid: this.getDataOnLogin.customerid,
                        reference: resp.reference,
                        username: this.getUsername
                    }, {
                        headers : {
                            'Authorization': this.getDataOnLogin.authorization,
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*'
                        }
                    })
                    .then(response => {
                        //stop appLoading
                        this.updateAppLoading(false)

                        console.log(response.data);
                        let responseData = response.data;


                        if (responseData.responsecode === '00') {

                            console.log('Account Fund By ard Successful');

                            // update dataOnLogin in the store appropriately
                            this.updateDataOnLoginAccounts(responseData.accountlist);
                            this.updateDataOnLoginTransactions(responseData.transactionlist);


                            //show the success modal and hide the amount modal
                            this.closeModal('fundAccountModal');
                            // equate the response message and show transferSuccessModal
                            this.successMessage = responseData.responsemessage;
                            this.openTransferSuccessModal();

                            this.notification = Object.assign({}, this.notification, {
                                message: responseData.responsemessage,
                                type: 'success'
                            })
                        } else {

                            this.closeModal('fundAccountModal');

                            // equate the response message and show transferFailModal
                            this.errorMessage = responseData.responsemessage;
                            this.openTransferFailModal();
                        }
                    })
                    .catch(error => {
                        // clear form inputs
                        console.log(error);

                        this.updateNetworkErrorState(true)
                    })
            },
            fundAccountModalHide(){
                // change the currentComponent in the store to 'dashboard'
                console.log('Quick Transfer Modal Close')
                this.amount = '';
                this.debitAcct = ''
            },

            openTransferSuccessModal(){
                //Open The TransferSuccessModal
                this.openModal('transferSuccessModal');
            },
            closeTransferSuccessModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferSuccessModal')
            },
            openTransferFailModal(){
                //Open The TransferSuccessModal
                this.openModal('transferFailModal');
            },
            closeTransferFailModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferFailModal')
            },

        },
        mounted(){
            this.$nextTick(()=>{});
        },
    }
</script>

<style scoped>
.a{ stroke:none;}

.account-info {
    padding: 0 0 15px 13px;
}
.account-info .alias {
    font-size: 8px !important;
    color: #808181;
}
.account-info .name {
    font-size: 14px !important;
    text-transform: uppercase;
    font-weight: 600;
    line-height: 14px;
    margin-bottom: 3px !important;
    margin-top: 2px;
}
.account-info .account {
    font-size: 10px !important;
    line-height: 10px;
    color: #6d0606;
}
.rubies-red{
    color: #6d0606 !important;
}
</style>